// extracted by mini-css-extract-plugin
export default {"container":"IconAvatar__container___iq92d","icon":"IconAvatar__icon___XSwy_"};